// extracted by mini-css-extract-plugin
module.exports = {"arrowTxt":"Empty_arrowTxt__2f-WC","arrow":"Empty_arrow__GbnBn"};